function Split({ children }) {
  return (
    <div className='flex flex-row'>
      {children}
    </div>
  );
}

export default Split;
